import type { Group } from "../../../api/groupsApi";

/** A group's name with the installation groups around it, outermost first: "Staff › Editors". */
export function groupPathName(group: Group, groups: readonly Group[]): string {
  const byId = new Map(groups.map((candidate) => [candidate.groupId, candidate]));
  const names = [group.name];
  const seen = new Set([group.groupId]);
  let parent = group.parentId === null ? undefined : byId.get(group.parentId);
  while (parent !== undefined && !seen.has(parent.groupId)) {
    names.unshift(parent.name);
    seen.add(parent.groupId);
    parent = parent.parentId === null ? undefined : byId.get(parent.parentId);
  }
  return names.join(" › ");
}

/** Some names, and how many more there are, for a short list in a table cell. */
export function shortNameList(names: readonly string[], shown = 5): { readonly names: readonly string[]; readonly more: number } {
  return { names: names.slice(0, shown), more: Math.max(0, names.length - shown) };
}
